export default () => {
    const initialize = (el) => {
        const imageContainer = el.querySelector('.steps__images');
        const images = Array.from(el.querySelectorAll('.steps__images img'));
        const itemsContainer = el.querySelector('.steps__items');
        const items = Array.from(el.querySelectorAll('.steps__item'));

        function handleResize() {
            el.style.setProperty('--image-offset', Math.floor(imageContainer.offsetHeight / 2) + 'px');
        }

        handleResize();
        window.addEventListener('resize', handleResize);

        function updateLineProgress() {
            const rect = itemsContainer.getBoundingClientRect();
            const centerPosition = window.innerHeight / 2 - rect.top;

            let progress = centerPosition / itemsContainer.offsetHeight;
            progress = Math.min(Math.max(progress, 0), 1);

            el.style.setProperty('--progress', progress);
        }

        updateLineProgress();
        window.addEventListener('scroll', updateLineProgress);

        function updateActiveItems() {
            for (let i = items.length - 1; i >= 0; i--) {
                const currentItem = items[i];
                const currentImage = images[i];
                const rect = currentItem.getBoundingClientRect();
                const centerPosition = window.innerHeight / 2 - rect.top;

                if (centerPosition >= 0) {
                    currentItem.classList.add('is-active');
                    currentImage.classList.add('is-active');
                } else {
                    currentItem.classList.remove('is-active');
                    currentImage.classList.remove('is-active');
                }
            }
        }

        updateActiveItems();
        window.addEventListener('scroll', updateActiveItems);
    };

    document.querySelectorAll('.steps').forEach((el) => {
        initialize(el);
    });
};
